import { LOCALES } from "../locales";

// Global
import global from "./fr-CA/global"
import views from "./fr-CA/views"
import components from "./fr-CA/components";

// Auth
import login from "./fr-CA/authentication/login";
import forgotPassword from "./fr-CA/authentication/forgotPassword";
import recovery from "./fr-CA/authentication/recovery";
import signup from "./fr-CA/authentication/signup";
import confirmAccount from "./fr-CA/authentication/confirm-account";

// Dashboard
import home from "./fr-CA/dashboard/home";

export default{
    [LOCALES.FRENCH] : {
        ...global,
        ...components,

        ...login,
        ...signup,
        ...confirmAccount,
        ...forgotPassword,
        ...recovery,
        ...home,
        ...views,
    },
}